export const defaultValues = {
  filterPanel: {
    startDate: '',
    endDate: '',
    radioGroup: [
      {
        value: 'completed',
        label: 'Completed',
        isChecked: false
      },
      {
        value: 'expired',
        label: 'Expired',
        isChecked: false
      },
      {
        value: 'pending',
        label: 'Pending',
        isChecked: false
      },
      {
        value: 'failed',
        label: 'Failed',
        isChecked: false
      },
      {
        value: 'cancelled',
        label: 'Cancelled',
        isChecked: false
      }
    ],
    checkboxGroup: []
  },
  sortPanel: {
    dropdownItems: [
      {
        label: 'Most recent',
        value: 'inserted_at',
        isSelected: false
      }
    ],
    radioGroup: [
      {
        value: 'asc',
        label: 'Ascending',
        isChecked: true
      },
      {
        value: 'desc',
        label: 'Descending',
        isChecked: false
      }
    ]
  }
};

export const selectedSort = {
  field: undefined,
  order: 'asc'
};

export const selectedFilter = {
  properties: undefined,
  status: undefined,
  startDate: undefined,
  endDate: undefined
};

export const filterQueryOptions: Record<string, { field: string; operator: string }> = {
  properties: {
    field: 'property_id',
    operator: '@>'
  },
  status: {
    field: 'status',
    operator: '='
  },
  startDate: {
    field: 'inserted_at',
    operator: '>'
  },
  endDate: {
    field: 'inserted_at',
    operator: '<'
  }
};
